import { useState, forwardRef, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import {
  Box, IconButton, Typography, useTheme,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Slide, Snackbar, Alert, SvgIcon,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AccountBalanceWallet from "@mui/icons-material/AccountBalanceWallet";
import AccountBalance from "@mui/icons-material/AccountBalance";
import Copyright from "@mui/icons-material/Copyright";
import Language from "@mui/icons-material/Language";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import EmailIcon from "@mui/icons-material/Email";
import { useMediaQuery } from "@mui/material";
import UserService from "../../api/services/UserService";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmLogoutDialog = ({ open, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    TransitionComponent={Transition}
    keepMounted
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: "20px",
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
        p: 2,
      },
    }}
  >
    <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
      <WarningAmberIcon color="warning" sx={{ fontSize: 48 }} />
    </DialogTitle>
    <DialogContent sx={{ textAlign: "center" }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Confirmer la déconnexion
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Souhaitez-vous vraiment vous déconnecter ? <br />
        Une nouvelle authentification sera nécessaire pour accéder à votre espace.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", mt: 1 }}>
      <Button onClick={onClose} variant="outlined" color="primary"
        sx={{ borderRadius: "10px", textTransform: "none", px: 3 }}>
        Annuler
      </Button>
      <Button onClick={onConfirm} variant="contained" color="error"
        sx={{ borderRadius: "10px", textTransform: "none", px: 3 }}>
        Me déconnecter
      </Button>
    </DialogActions>
  </Dialog>
);

const GradientIcon = ({ IconComponent, ...props }) => (
  <SvgIcon {...props} sx={{ fontSize: "1.5rem", transition: "transform 0.2s ease", "&:hover": { transform: "scale(1.15)" } }}>
    <defs>
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#2a5fa9" />
        <stop offset="20%" stopColor="#3a7fb5" />
      </linearGradient>
    </defs>
    <IconComponent sx={{ fill: "url(#gradient)" }} />
  </SvgIcon>
);

const Item = ({ title, to, icon, selected, setSelected, onClickMobile }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
        ...(selected === title && { backgroundColor: colors.primary[500] }),
      }}
      onClick={() => {
        setSelected(title); 
        if (onClickMobile) onClickMobile();
      }}
      icon={icon}
    >
      <Typography sx={{ fontWeight: selected === title ? "bold" : "normal" }}>
        {title}
      </Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({ isSidebar, onLogout, isCollapsed: isCollapsedProp, setIsCollapsed: setIsCollapsedProp }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  console.log(" pathname actuel:", location.pathname);

  const isCollapsed = setIsCollapsedProp ? isCollapsedProp : isMobile;
  const setIsCollapsed = setIsCollapsedProp || (() => { });

  const [selected, setSelected] = useState("");
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const userRole = localStorage.getItem("user_role");
  const userData = JSON.parse(localStorage.getItem("user_data")) || {};

  useEffect(() => {
    console.log(" useEffect location déclenché:", location.pathname);
    const routeToTitle = {
      "/dashboard": "Tableau de bord",
      "/utilisateurs": "Gestion des utilisateurs",
      "/alerte": "Gestion des alertes",
      "/marques": "Marques",
      "/NomDomaine": "Noms de domaine",
      "/brevets": "Brevets",
      "/contrats": "Contrats",
      "/EditProfil": "Mon profil",
      "/Calendrier": "Calendrier",
      "/contact": "Contact",
    };
    const title = routeToTitle[location.pathname];
    console.log(" title trouvé:", title);
    if (title) setSelected(title);
  }, [location.pathname]);


  //  Synchroniser la sélection avec l'URL active
  useEffect(() => {
    const routeToTitle = {
      "/dashboard": "Tableau de bord",
      "/utilisateurs": "Gestion des utilisateurs",
      "/alerte": "Gestion des alertes",
      "/marques": "Marques",
      "/NomDomaine": "Noms de domaine",
      "/brevets": "Brevets",
      "/contrats": "Contrats",
      "/EditProfil": "Mon profil",
      "/Calendrier": "Calendrier",
      "/contact": "Contact",
    };
    const title = routeToTitle[location.pathname];
    if (title) setSelected(title);
  }, [location.pathname]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (userRole === "gestionnaire" && userData.id) {
          const token = localStorage.getItem("token");
          const data = await UserService.getProfile(userData.id, token, userRole);
          setUserInfo(data);
          localStorage.setItem("user_data", JSON.stringify(data));
        }
      } catch (error) {
        console.error("Erreur chargement profil :", error);
      }
    };
    fetchUserData();
  }, []);

  const handleLogoutClick = () => setLogoutDialogOpen(true);
  const handleCloseDialog = () => setLogoutDialogOpen(false);
  const handleCloseSnackbar = () => setShowSuccess(false);

  const handleConfirmLogout = async () => {
    setLogoutDialogOpen(false);
    setShowSuccess(true);
    setTimeout(() => { if (onLogout) onLogout(); }, 1200);
  };

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  const handleItemClickMobile = () => {
    if (isMobile) setIsCollapsed(true);
  };

  return (
    <Box
      sx={{
        position: "fixed", left: 0, top: 0, height: "100vh", zIndex: 1200,
        "& .pro-sidebar-inner": { background: `${colors.primary[400]} !important` },
        "& .pro-icon-wrapper": { backgroundColor: "transparent !important" },
        "& .pro-inner-item": { padding: "5px 35px 5px 20px !important", transition: "all 0.3s ease" },
        "& .pro-inner-item:hover": { color: "#000 !important", fontWeight: "bold !important" },
        "& .pro-menu-item.active": {
          color: "#000 !important", fontWeight: "bold !important",
          backgroundColor: "rgba(255, 255, 255, 0.15) !important",
        },
        "& .pro-sidebar": {
          position: "fixed", height: "100vh",
          width: isCollapsed ? (isMobile ? "0px" : "80px") : (isMobile ? "100vw" : "280px"),
          backgroundColor: `${colors.primary[400]} !important`,
          overflow: "auto", display: "flex", flexDirection: "column",
          transition: "width 0.3s ease",
          zIndex: isMobile ? 1300 : 1200, left: 0, top: 0,
        },
      }}
    >
      {/* Bouton toggle */}
      <Box sx={{
        position: "fixed",
        top: isMobile ? (isCollapsed ? 10 : 13) : 13,
        left: 10, zIndex: 1400,
        backgroundColor: "white", borderRadius: "50%",
        width: 40, height: 40,
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)", transition: "all 0.3s ease",
      }}>
        <IconButton onClick={toggleSidebar}
          sx={{
            color: colors.grey[700], width: "100%", height: "100%", borderRadius: "50%",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.08)" }
          }}>
          <MenuOutlinedIcon />
        </IconButton>
      </Box>

      <ProSidebar
        height="100vh"
        width={isCollapsed ? (isMobile ? "0px" : "1px") : (isMobile ? "100vw" : "280px")}
        style={{ visibility: isMobile && isCollapsed ? "hidden" : "visible" }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Menu iconShape="square" style={{ flex: 1 }}>
            {!isCollapsed && (
              <>
                {/* Logo */}
                <Box mb="25px">
                  <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: "15px" }}>
                    {/* SVG logo inchangé */}
                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 119.21 59.51" style={{ width: "120px", height: "120px", cursor: "pointer" }}>
                      <defs>
                        <style>{`
                          .cls-1 { fill: url(#Dégradé_sans_nom_5); }
                          .cls-2 { fill: #1d1d1b; }
                          .cls-3 { fill: #263238; }
                          .cls-4 { fill: url(#Dégradé_sans_nom_5-2); }
                        `}</style>
                        <linearGradient id="Dégradé_sans_nom_5" x1="10.92" y1="38.19" x2="-.42" y2="38.02" gradientUnits="userSpaceOnUse">
                          <stop offset="0%" stopColor="#3269ab" /><stop offset="100%" stopColor="#8fc68b" />
                        </linearGradient>
                        <linearGradient id="Dégradé_sans_nom_5-2" x1="14.14" y1="29.76" x2="43.63" y2="29.76" xlinkHref="#Dégradé_sans_nom_5" />
                      </defs>
                      <path className="cls-2" d="M41.43,47.74v1.99h5.96v5.86c-.87.62-1.82,1.1-2.84,1.44-1.03.35-2.05.52-3.09.52-1.67,0-3.22-.41-4.64-1.23-1.42-.82-2.55-1.92-3.38-3.32-.82-1.4-1.23-2.93-1.23-4.61s.41-3.14,1.21-4.52c0-.02.02-.03.03-.04.83-1.38,1.95-2.49,3.36-3.3,1.41-.82,2.94-1.23,4.62-1.23h.03c1.23,0,2.42.22,3.55.66,1.14.44,2.15,1.08,3.04,1.91l1.24-1.52c-1.05-.93-2.26-1.66-3.62-2.18-.9-.35-1.83-.58-2.78-.68-.47-.07-.97-.09-1.46-.09-2.06,0-3.97.49-5.72,1.48-1.74.98-3.12,2.31-4.14,3.99-.27.44-.49.89-.69,1.36-.55,1.3-.83,2.69-.83,4.17,0,2,.51,3.86,1.52,5.56,1.02,1.69,2.38,3.04,4.12,4.03,1.73.99,3.61,1.49,5.66,1.49,1.44,0,2.87-.26,4.3-.77,1.42-.5,2.65-1.2,3.7-2.09v-8.88h-7.92Z" />
                      <path className="cls-2" d="M69.18,43.02v16.26h-2.11v-3.88c-.54,1.28-1.34,2.26-2.41,2.92-1.07.66-2.35,1-3.86,1.02-1.92,0-3.43-.56-4.52-1.69-1.09-1.13-1.63-2.67-1.63-4.64v-9.99h2.11v9.5c0,1.53.42,2.73,1.26,3.58s1.99,1.29,3.46,1.29c1.74-.02,3.1-.62,4.1-1.78.99-1.17,1.49-2.7,1.49-4.61v-7.98h2.11Z" />
                      <path className="cls-2" d="M85.44,59.29l-.03-2.73c-.64.95-1.48,1.66-2.51,2.13-1.04.47-2.22.7-3.57.7-1.1,0-2.06-.21-2.9-.64-.84-.42-1.49-1.01-1.94-1.75s-.68-1.58-.68-2.51c0-1.41.54-2.51,1.63-3.32,1.09-.81,2.58-1.21,4.48-1.21h5.46v-1.24c0-1.28-.38-2.28-1.15-2.98-.77-.7-1.88-1.06-3.35-1.06-1.74,0-3.49.65-5.25,1.96l-.93-1.43c1.1-.77,2.14-1.33,3.14-1.69.99-.36,2.13-.54,3.41-.54,1.96,0,3.49.49,4.56,1.47,1.08.98,1.62,2.34,1.64,4.08l.03,10.77h-2.05ZM83.38,56.63c1-.67,1.68-1.62,2.03-2.84v-2.23h-5.25c-1.43,0-2.51.24-3.26.71-.74.48-1.12,1.19-1.12,2.14s.36,1.75,1.07,2.34,1.66.88,2.84.88c1.45,0,2.67-.34,3.68-1.01Z" />
                      <path className="cls-2" d="M97.44,43.97c1-.65,2.21-.99,3.62-1.01v1.95c-1.72-.02-3.10.48-4.14,1.51-1.05,1.02-1.64,2.42-1.78,4.17v8.69h-2.08v-16.26h2.08v3.79c.54-1.24,1.31-2.19,2.31-2.84Z" />
                      <path className="cls-2" d="M119.21,36.26v23.03h-2.08v-3.72c-.62,1.22-1.49,2.17-2.61,2.84-1.12.67-2.42,1.01-3.91,1.01s-2.90-.35-4.10-1.06c-1.20-.7-2.13-1.69-2.79-2.95-.66-1.26-.99-2.69-.99-4.28s.34-3.01,1.01-4.25c.67-1.24,1.60-2.21,2.79-2.92,1.19-.7,2.54-1.06,4.05-1.06s2.80.34,3.93,1.02c1.13.68,2,1.63,2.62,2.86v-10.52h2.08ZM114.15,56.79c.93-.55,1.66-1.31,2.19-2.28.53-.97.79-2.08.79-3.32s-.26-2.35-.79-3.34c-.53-.98-1.26-1.75-2.19-2.31-.93-.56-1.99-.84-3.17-.84s-2.23.28-3.17.84c-.93.56-1.67,1.33-2.20,2.31-.54.98-.81,2.09-.81,3.34s.26,2.35.79,3.32c.53.97,1.26,1.73,2.20,2.28.94.55,2,.82,3.18.82s2.23-.27,3.17-.82Z" />
                      <path className="cls-1" d="M11.34,20.99v34.42c-2.43-1.15-4.65-2.58-6.61-4.23-.77-.64-1.50-1.32-2.19-2.03-.54-.56-1.06-1.14-1.55-1.73-.65-.79-.99-1.74-.99-2.71v-23.72h11.34Z" />
                      <path className="cls-3" d="M11.31,0c-1.84,1-3.57,2.17-5.15,3.48h0c-.11.10-.21.19-.33.28-.04.02-.06.04-.09.08-1.15.99-2.22,2.06-3.20,3.20C1.62,8.11.77,9.24,0,10.42v.03h11.34V0h-.04Z" />
                      <path className="cls-3" d="M26.06,18.01c-1.58.94-2.38-.30-3.84-.69l-5.73.66v-3.69l5.60.67c1.55-.08,2.04-1.74,3.89-.74,1.49.81,1.54,2.92.09,3.79Z" />
                      <path className="cls-4" d="M43.63,15.67c0,9.10-6.85,15.72-16.08,15.72h-1.42v24.64h-.02v3.35c-.98.08-1.98.13-2.97.13-1.29,0-2.57-.08-3.81-.23-.79-.10-1.57-.22-2.34-.37-.97-.19-1.92-.42-2.85-.70V20.97h11.99c3.15,0,5.23-2.19,5.23-5.26s-2.08-5.27-5.23-5.27h-11.99V0h13.41c9.23,0,16.08,6.58,16.08,15.67Z" />
                    </svg>
                  </Box>
                  <Box textAlign="center">
                    <Typography variant="h5" color={colors.greenAccent[500]}>
                      {userRole === "admin"
                        ? "Administrateur"
                        : `Gestionnaire (${(userInfo?.societes || userData?.societes || [])
                          .map((s) => s.nom).join(", ") || "Aucune société"})`}
                    </Typography>
                  </Box>
                </Box>

                {/* ✅ MENU — même structure pour admin et gestionnaire */}
                <Box sx={{ flexGrow: 1, paddingLeft: "10%" }}>

                  {/* Tableau de bord — tous les rôles */}
                  <Item title="Tableau de bord" to="/dashboard"
                    icon={<GradientIcon IconComponent={HomeOutlinedIcon} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />

                  {/* ✅ Gestion des utilisateurs — ADMIN UNIQUEMENT */}
                  {userRole === "admin" && (
                    <>
                      <Typography variant="h6" color={colors.grey[300]} sx={{ m: "15px 0 5px 20px" }}>
                        Administration
                      </Typography>
                      <Item title="Gestion des utilisateurs" to="/utilisateurs"
                        icon={<GradientIcon IconComponent={PeopleOutlinedIcon} />}
                        selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                    </>
                  )}

                  {/* Gestion des alertes — tous les rôles */}
                  <Item title="Gestion des alertes" to="/alerte"
                    icon={<GradientIcon IconComponent={NotificationsOutlinedIcon} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />

                  {/* Propriété intellectuelle — tous les rôles */}
                  <Typography variant="h6" color={colors.grey[300]} sx={{ m: "15px 0 5px 20px" }}>
                    Propriété intellectuelle
                  </Typography>
                  <Item title="Marques" to="/marques"
                    icon={<GradientIcon IconComponent={Copyright} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                  <Item title="Noms de domaine" to="/NomDomaine"
                    icon={<GradientIcon IconComponent={Language} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                  <Item title="Brevets" to="/brevets"
                    icon={<GradientIcon IconComponent={AccountBalance} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                  <Item title="Contrats" to="/contrats"
                    icon={<GradientIcon IconComponent={AccountBalanceWallet} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />

                  {/* Espace personnel — tous les rôles */}
                  <Typography variant="h6" color={colors.grey[300]} sx={{ m: "15px 0 5px 20px" }}>
                    Espace personnel
                  </Typography>
                  <Item title="Mon profil" to="/EditProfil"
                    icon={<GradientIcon IconComponent={PersonOutlinedIcon} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                  <Item title="Calendrier" to="/Calendrier"
                    icon={<GradientIcon IconComponent={CalendarTodayOutlinedIcon} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                  <Item title="Contact" to="/contact"
                    icon={<GradientIcon IconComponent={EmailIcon} />}
                    selected={selected} setSelected={setSelected} onClickMobile={handleItemClickMobile} />
                </Box>
              </>
            )}
          </Menu>



          {!isCollapsed && (
            <Box sx={{ padding: "10px 20px 20px", position: "sticky", bottom: 0, backgroundColor: colors.primary[400], zIndex: 10 }}>              <Button onClick={handleLogoutClick} variant="contained" fullWidth
              sx={{
                borderRadius: "10px", textTransform: "none", fontWeight: "bold",
                background: "linear-gradient(90deg, #2a5fa9 0%, #3a7fb5 20%, #4a9fc0 40%, #5ab8a0 60%, #70bd8d 80%, #8fc68b 100%)",
                "&:hover": { transform: "scale(1.02)", transition: "all 0.2s ease" },
              }}>
              Se déconnecter
            </Button>
            </Box>
          )}
        </Box>
      </ProSidebar>

      <ConfirmLogoutDialog open={logoutDialogOpen} onClose={handleCloseDialog} onConfirm={handleConfirmLogout} />
      <Snackbar open={showSuccess} autoHideDuration={2000} onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ borderRadius: "10px", boxShadow: 3 }}>
          Déconnexion réussie
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Sidebar;